import { presenceChip } from '../utils/presence'

/**
 * The kraal presence chip (plan smartkraal-owner-experience B1): one markup for
 * the list row, the wall tile and the animal page header. Pass the animal (the
 * cattle-list row shape) or a ready `chip` from `presenceChip()`; sizing comes
 * from `className`.
 */
export default function PresenceChip({ animal, chip: given, className = 'px-2 py-0.5 text-xs' }) {
  const chip = given || presenceChip(animal)
  if (!chip) return null
  return (
    <span className={`rounded-full font-medium ${chip.cls} ${className}`} title={chip.title}
          data-testid="presence-chip" data-presence={chip.key}>
      {chip.label}
    </span>
  )
}
